import getAxiosInstance from '../../helpers/get_axios_instance'
import Axios from 'axios'
import lrsAdapter from '../../helpers/lrs_adapter'

class CargaEntranteAutomotorCalado {
  static anularAnalisis (numero) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`carga_entrante_automotor_calado?r=` +
      `{"clave":{"carta_de_porte_automotor": "${numero}"}}`)

    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static adaptToBackend (analisisCalado = {}) {
    const {
      calle,
      condicionIngreso,
      condicionIngresoSegunda,
      humedad,
      modoIngreso,
      numero,
      puestoCalado,
      peritoCalador,
      fumigado,
      pendienteAutorizar,
      caravana,
      cereal,
      calleDeIngreso,
      zarandeo,
      motivoDeZarandeo
    } = analisisCalado

    return {
      cartaDePorteAutomotor: numero,
      estadoCalificacion: modoIngreso,
      calificacionCereal: condicionIngreso,
      calificacionCerealDos: condicionIngresoSegunda,
      humedad: Number(humedad) / 10,
      fumigado: fumigado,
      motivoDeZarandeo: motivoDeZarandeo,
      actaSenasa: null,
      autorizado: !pendienteAutorizar,
      calleDeCalado: modoIngreso === 'R' ? null : calle,
      peritoCalador: peritoCalador,
      puestoDeCalado: puestoCalado,
      caravana: caravana,
      cereal: cereal,
      calleDeIngreso: calleDeIngreso,
      zarandeo: zarandeo
    }
  }

  static adaptToBackendUpdate (updateCalado = {}) {
    const {
      fechaDeCalado,
      peritoCalador,
      condicionIngreso,
      condicionIngresoSegunda,
      humedad,
      modoIngreso,
      numero,
      fumigado,
      pendienteAutorizar,
      caravana,
      calle,
      cereal,
      calleDeIngreso,
      zarandeo,
      motivoDeZarandeo
    } = updateCalado

    return {
      fechaDeCalado: fechaDeCalado,
      peritoCalador: peritoCalador,
      cartaDePorteAutomotor: numero,
      estadoCalificacion: modoIngreso,
      calificacionCereal: condicionIngreso || null,
      calificacionCerealDos: condicionIngresoSegunda || null,
      humedad: Number(humedad) / 10,
      fumigado: fumigado,
      autorizado: !pendienteAutorizar,
      caravana: caravana,
      calleDeCalado: modoIngreso === 'R' ? null : calle,
      cereal: cereal,
      calleDeIngreso: calleDeIngreso,
      zarandero: zarandeo,
      motivoDeZarandeo: motivoDeZarandeo
    }
  }

  static altaAnalisisCalado (analisisCalado = {}) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(analisisCalado)
    const promise = axios.post(`carga_entrante_automotor_calado`, { valores: { ...valores } })
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static updateAnalisisCalado (updateCalado = {}) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendUpdate(updateCalado)
    const promise = axios.put(`carga_entrante_automotor_calado`, { valores: { ...valores }, clave: { carta_de_porte_automotor: updateCalado.numero, fecha_de_calado: updateCalado.fechaDeCalado } })
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static updateCalleDeCalado (numero, fechaCalado, calleDeCalado) {
    const axios = getAxiosInstance()
    const promise = axios.put(`carga_entrante_automotor_calado`, { valores: { calle_de_calado: calleDeCalado }, clave: { carta_de_porte_automotor: numero, fecha_de_calado: fechaCalado } })
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static getPendienteAutoriz () {
    const orden = '{"orden": ["d:fecha_de_calado"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_cea_pendiente_de_autorizacion_listado?r=${orden}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static autorizarPendientesAutoriz (pendientes) {
    const axios = getAxiosInstance()
    const autorizarPendiente = (cea) => {
      const promise = axios.delete(`cea_postergada_administrativamente?r=` +
        `{"clave":{"carta_de_porte_automotor": "${cea.cartaDePorteAutomotor}"}}`)
      return promise.then(lrsAdapter, lrsAdapter)
    }

    const promises = pendientes instanceof Array
      ? pendientes.map(autorizarPendiente)
      : [autorizarPendiente(pendientes)]

    return Promise.all(promises)
  }

  static rechazarPendientesAutoriz (pendientes) {
    const axios = getAxiosInstance()
    const rechazarPendiente = (cea) => {
      const promise = axios.post(`/cea_rechazada_administrativamente`,
        `{"valores": {"carta_de_porte_automotor": "${cea.cartaDePorteAutomotor}"}}`)
      return promise.then(lrsAdapter, lrsAdapter)
    }

    const promises = pendientes instanceof Array
      ? pendientes.map(rechazarPendiente) : [rechazarPendiente(pendientes)]

    return Promise.all(promises)
  }

  static actualizarEntregadorPendientesAutoriz (pendientes, entregador) {
    const axios = getAxiosInstance()
    const autorizarPendiente = (cea) => {
      console.log('Cea a procesar', cea, entregador)
      const promise = axios.put(`/carga_entrante_automotor`,
        `{"valores": {"entregador_autoriza": "${entregador}"},
        "clave":{"carta_de_porte_automotor": "${cea.cartaDePorteAutomotor}", "fecha_de_calado": "${cea.fechaDeCalado}"}}`)
      return promise.then(lrsAdapter, lrsAdapter)
    }

    const promises = pendientes instanceof Array
      ? pendientes.map(autorizarPendiente)
      : [autorizarPendiente(pendientes)]

    return Promise.all(promises)
  }

  static rechazarEnAfip (numero, ctg, motivo) {
    const axios = getAxiosInstance()
    const promise = axios.post(`cea_rechazada_en_afip`,
      `{"valores": {"carta_de_porte_automotor": "${numero}", "ctg": "${ctg}", "motivo_rechazo": "${motivo}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static rechazarPendientesEnAfip (numero, ctg, motivo) {
    const axios = getAxiosInstance()
    const promise = axios.post(`cea_rechazada_en_afip`,
      `{"valores": {"carta_de_porte_automotor": "${numero}", "ctg": "${ctg}", "motivo_rechazo": "${motivo}"}}`)
    return promise
  }

  static rechazarPendientesEnAfipArreglo (pendientesSeleccionados) {
    const axios = getAxiosInstance()
    // Rechaza pendientes en afip o se esta utilizando
    var promise = []
    if (pendientesSeleccionados.length > 0) {
      for (var i = 0, len = pendientesSeleccionados.length; i < len; i++) {
        const cpe = `{"valores": {"carta_de_porte_automotor": "${pendientesSeleccionados[i].numero}", 
          "ctg": "${pendientesSeleccionados[i].ctg}", "motivo_rechazo": "Rechazo administrativo"}}`
        promise.push(axios.post(`/cea_rechazada_en_afip`, `${cpe}`))
      }
      return Axios.all(promise)
        .then((responses) => {
          responses.map(response => {
            if (response.data.estado !== 'exito') throw new Error('No se pudo completar la operacion.')
            return response.data.estado
          })
        })
        .catch((err) => {
          console.log('Error', err)
        })
    }
  }

  // Metodo utilizado en Calado para rechazar solo en Afip
  static rechazarCpeEnAfip (cpeSucursal, cpeSecuencia, titularCpe) {
    const axios = getAxiosInstance()
    const promise = axios.get(`rechazarcpe?r=` +
      `{"parametros": {"cpe_sucursal": ${cpeSucursal}, "cpe_secuencia": ${cpeSecuencia}, "titular_cpe": ${titularCpe}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }
}

export default CargaEntranteAutomotorCalado
